import styled from 'styled-components';
import { C_POSTBOX, C_METAL, C_EBON } from '@bbc/psammead-styles/colours';
var InlineLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "InlineLink",
  componentId: "hkwpaz-0"
})(["color:", ";border-bottom:1px solid ", ";text-decoration:none;&:visited{color:", ";border-bottom:1px solid ", ";}&:focus,&:hover{border-bottom:2px solid ", ";color:", ";}"], C_EBON, C_POSTBOX, C_METAL, C_METAL, C_POSTBOX, C_POSTBOX);
export default InlineLink;